import PropTypes from "prop-types";
import React from "react";
import Notification from "./notification";

const Notifications = ({ notifications = [], remove, ...props }) =>
  notifications && notifications.length
    ? <div>
        {notifications.map(
          notification =>
            notification
              ? <Notification
                  key={notification.id}
                  {...notification}
                  handleOnClick={() => remove(notification.id)}
                  {...props}
                />
              : null
        )}
      </div>
    : null;

Notifications.propTypes = {
  notifications: PropTypes.array.isRequired,
  remove: PropTypes.func.isRequired,
};

export default Notifications;



// WEBPACK FOOTER //
// ./components/notifications/notifications.js